import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';

import { LoginServiceService } from '../service/login-service.service';
import { Router } from '@angular/router';
import { AlertComponent } from "../alert/alert.component";

interface DispositivoAttributes {
  isMobile: boolean;
}

@Component({
  selector: 'app-loginadm',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NavbarComponent, AlertComponent],
  templateUrl: './loginadm.component.html',
  styleUrls: ['./loginadm.component.scss'],
  
})
export class LoginadmComponent{
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  
  //Variavel para dispositivo PC vs Mobile
  public dispositivo: DispositivoAttributes; 



  //Variavel do formulario
  public loginForm: FormGroup;

  //Variavel para o tipo de alerta
  public alertType: boolean = false;

  constructor( private fb: FormBuilder, private loginAdminService: LoginServiceService, private router: Router) { 
    this.dispositivo = { isMobile: false }; 
    this.loginForm = this.fb.group({
      usuario: ['', [Validators.required]],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    //this.dispositivo.isMobile = this.platform.is('mobile') || this.platform.is('mobileweb');
  }

  public onSubmit() {

    this.loginAdminService.loginAdmin(this.loginForm.value.usuario, this.loginForm.value.password).subscribe((response: any)=>{
      
      //Salva o token no localStorage
      localStorage.setItem('token', response.token);
      localStorage.setItem('name', response.username);
      localStorage.setItem('uL', btoa(response.usernivel));
      //Redireciona para o painel de clientes
      this.router.navigateByUrl('/admin/panel/clientes');
      
    },(error: any)=>{

      console.log("Erro: ",error.error);
      this.alertComponent.showAlert(`Erro ao realizar login: ${error?.error?.retorno}`, "error");
    })
  }

  
}
